import React, { useEffect, useState } from "react";
import { Grid, Card, Button, Box, OutlinedInput, FormHelperText, InputLabel } from "@mui/material";
import { useFormik } from "formik";
import { getCallerIDRequest, AddCallerIDRequest } from "../../../api/api";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CustomPagination from "../../../pagination/CustomPagination";
import Loader from "../../../Loader/loader";
function CallerIDTable() {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const formik = useFormik({
    initialValues: {
      caller_id: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        setIsLoading(true);

        const body = {
          caller_id: values.caller_id,
        };

        const res = await AddCallerIDRequest(body);

        // Success ke baad
        resetForm();
        setPage(1);

        // Table refresh
        fetchData();
      } catch (error) {
        console.error("Add Caller ID Error:", error);
      } finally {
        setIsLoading(false);
      }
    },
  });

  const columns = [
    // { Header: "Date", accessor: "created_at", align: "center" },
    { Header: "Caller ID", accessor: "caller_id", align: "center" },
  ];

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const cleanFilters = Object.fromEntries(
        Object.entries(formik.values).filter(([_, v]) => v !== "")
      );

      const res = await getCallerIDRequest(page, rowsPerPage, cleanFilters);

      const response = res?.data || {};
      const cdrData = response.data || [];
      const formattedRows = cdrData.map((item) => ({
        caller_id: (
          <MDTypography variant="button" fontWeight="medium">
            {item.caller_id || "N/A"}
          </MDTypography>
        ),
      }));

      setRows(formattedRows);
      setTotalCount(response.total ?? cdrData.length);
    } catch (error) {
      console.error("CDR fetch error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3}>
        <Grid container spacing={2} alignItems="center" sx={{ p: 2 }}>
          <Grid item xs={12} sm={4} md={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginLeft: 3,
                marginTop: 2,
              }}
            >
              <InputLabel
                htmlFor="caller_id"
                sx={{
                  minWidth: "60px",
                  mb: 0,
                }}
              >
                Caller ID
              </InputLabel>

              <OutlinedInput
                type="text"
                id="caller_id"
                name="caller_id"
                fullWidth
                placeholder="Enter Caller ID"
                value={formik.values.caller_id}
                onChange={formik.handleChange}
                error={formik.touched.caller_id && Boolean(formik.errors.caller_id)}
              />
            </Box>

            {formik.touched.caller_id && formik.errors.caller_id && (
              <FormHelperText error>{formik.errors.caller_id}</FormHelperText>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <Button
              fullWidth
              variant="outlined"
              onClick={formik.handleSubmit}
              sx={{
                height: "40px",
                marginTop: 2,
                backgroundColor: "green",
                color: "white",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "green" },
              }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <MDTypography
              variant="h6"
              color="white"
              sx={{ backgroundColor: "#1976d2", p: 2, borderRadius: "4px" }}
            >
              Caller ID
            </MDTypography>

            {isLoading ? (
              <Box display="flex" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
                <Loader />
              </Box>
            ) : rows.length === 0 ? (
              <MDTypography sx={{ p: 3, textAlign: "center", color: "gray" }}>
                No Record Found
              </MDTypography>
            ) : (
              <>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  loading={isLoading}
                />
                {totalCount > rowsPerPage && (
                  <CustomPagination
                    count={totalCount}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => {
                      setRowsPerPage(parseInt(e.target.value, 100));
                      setPage(1);
                    }}
                  />
                )}
              </>
            )}
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default CallerIDTable;
